import React from "react";
import { Button } from "antd";
import { UserOutlined } from "@ant-design/icons";

export const WorkplanExportButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <Button icon={<UserOutlined />} type="primary" size="small" onClick={onClick}>
      Workplan
    </Button>
  );
};
